import { type ReactNode, createContext, useContext, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type NumbersLayerStore } from 'pages/settings/pages/numbers/store/numbersLayerStore'
import { BuyNumberStepsStore } from 'pages/settings/pages/numbers/pages/BuyNumber/store/BuyNumberStepsStore'

const BuyNumberStepsContext = createContext<BuyNumberStepsStore | null>(null)

export const useBuyNumberStepsContext = () => {
  const context = useContext(BuyNumberStepsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with BuyNumberStepsProvider')

  return context
}

export const BuyNumberStepsProvider = ({
  numbersLayerStore,
  children,
}: {
  numbersLayerStore: NumbersLayerStore
  children: ReactNode
}) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new BuyNumberStepsStore(numbersLayerStore, entities), [])

  return <BuyNumberStepsContext.Provider value={store}>{children}</BuyNumberStepsContext.Provider>
}
